import { FreeFieldDefinitionDetailSection } from "../FreeFieldDefinitionDetailSection";
import FreeFieldDefinitionOptionsPanel from "../FreeFieldDefinitionOptionsPanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";

const FreeFieldDefinitionDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.FreeFieldDefinitionDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <FreeFieldDefinitionDetailSection
        freeFieldDefinition={viewModel.freeFieldDefinition}
        freeFieldProfileWithPermission={viewModel.freeFieldProfilePermissions}
        mainArea={viewModel.mainArea}
        freeFieldCategory={viewModel.freeFieldCategory}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <FreeFieldDefinitionOptionsPanel
        optionsPanelData={viewModel.optionsPanel}
        listUrl={viewModel.listUrl}
        freeFieldDefinitionId={viewModel.freeFieldDefinition.freeFieldDefinitionId}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}

export default FreeFieldDefinitionDetailApp;